import React, {useEffect, useState} from "react";
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from "react-redux";

const Modal = ({handler, children, onSubmit, onClose, fallDown, trigger, size, title, showButtons=true}) =>
{
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const [showModal, SetShowModal] = useState(false);

	useEffect(() =>
	{
		if(fallDown)
		{
			SetShowModal(false);
			if(onClose)
			{
				onClose();
			}
		}
	// eslint-disable-next-line
	}, [fallDown]);

	useEffect(() =>
	{
		if(trigger)
		{
			SetShowModal(true);
		}
	// eslint-disable-next-line
	}, [trigger]);

	const HandleSubmit = (keepOpen=false) =>
	{
		if(onSubmit)
		{
			if(onSubmit())
			{
				if(!keepOpen)
				{
					SetShowModal(false);
				}
			}
		}
		else if(!keepOpen)
		{
			SetShowModal(false);
		}
	};
	
	const HandleDecline = () =>
	{
		if(onClose)
		{
			onClose();
		}
		SetShowModal(false);
	};
	return (
		<>
			<span className='cursor-pointer' onClick={() => SetShowModal(true)}>{handler ? handler : <i className='fa fa-link py-3 px-2 bg-primary text-white rounded-md'></i>}</span>
			{showModal ?
			<>
			<div className="flex justify-center items-center fixed z-50 w-full md:min-w-[35rem] md:w-2/3 mx-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" style={size}>
				<div className="relative w-full z-50 h-full">
					<div className="modal flex flex-col rounded-lg shadow-lg relative w-full h-full">
						<div className="flex items-center justify-between p-3 border-b border-secondaryBorder">
							<span className="text-sm">{title ? title : null}</span>
							<i className="fa fa-times cursor-pointer px-2 hover:text-danger" onClick={HandleDecline}></i>
						</div>
						<div className="relative p-3 flex-auto text-sm h-full overflow-auto">{children}</div>
						{showButtons && (onSubmit || onClose) ? 
						<div className="flex justify-end p-3">
							{onSubmit ? <button className="btn-primary" onClick={() => HandleSubmit(false)}>{language["COMPONENTS"]["SAVE"]}</button> : null}
							{onClose ? <button className="btn secondary" onClick={HandleDecline}>{language["COMPONENTS"]["DECLINE"]}</button> : null}
						</div>
						: null }
					</div>
				</div>
			</div>
			<div className="opacity-50 fixed inset-0 z-40 bg-black" onClick={HandleDecline}></div>
			</> : null}
		</>
	);
}

export default Modal;